import { registerPublicParameters } from './tasks/registerPublicParameters';

export function bootstrap() {
    return Promise.all([
        registerPublicParameters(),
    ]);
}
